import flatten from 'lodash/flatten'
import type {RlSkillUspIdT} from '@freckle/educator-entities/ts/common/types/rl-skill-usp-id'
import type {RlStandardIdT} from '@freckle/educator-entities/ts/common/types/rl-standard-id'
import type {
  GrammarQuestionT,
  GrammarQuestionShellT
} from '@freckle/educator-entities/ts/ela/common/models/grammar-question'
import {
  parseGrammarQuestion,
  parseGrammarQuestionShells
} from '@freckle/educator-entities/ts/ela/common/models/grammar-question'
import {
  curriculaClient,
  extractData,
  fancyClient
} from '@freckle/educator-entities/ts/openapi-clients'

export function fetchGrammarQuestion(questionUuid: string): Promise<GrammarQuestionT> {
  return curriculaClient
    .GET('/ela/grammar-questions/{uuid}.json', {
      params: {
        path: {
          uuid: questionUuid
        }
      }
    })
    .then(extractData)
    .then((res: unknown[]) => parseGrammarQuestion(res[0]))
}

export async function fetchArbitraryGrammarQuestionShells(
  targetSkillId: RlSkillUspIdT | null,
  targetStandardId: RlStandardIdT | null,
  elaStandardSetId: string,
  numQuestions: number,
  isWritingDomain: boolean,
  excludedQuestions: string[] = []
): Promise<Array<GrammarQuestionShellT>> {
  const response = await fancyClient
    .POST('/3/{ContentAreaP-ContentArea}/questions/arbitrary', {
      params: {
        path: {
          'ContentAreaP-ContentArea': 'ela'
        }
      },
      body: {
        targetSkillId,
        targetStandardId,
        standardSetId: elaStandardSetId,
        numQuestions,
        excludedQuestions,
        isWritingDomain
      }
    })
    .then(extractData)

  const questions = flatten(response.map(r => r.questions))
  return parseGrammarQuestionShells(questions)
}
